import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    DeviceSourceSet,
    RenderOptimizedVariants,
} from 'src/domains/layouts/webview/components/common/lazyLoadingImage/common/ImagePictureHelpers';
import { LazyLoadingImageRawPropsType } from 'src/domains/layouts/webview/components/common/lazyLoadingImage/common/LazyLoadingImageRaw.type';
import { ImageRaw } from 'src/domains/layouts/webview/components/common/lazyLoadingImage/common/LazyLoadingImageRaw.style';
import { LazyImageLoadState } from 'src/domains/layouts/state/lazyImageState/LazyImagesState';

export const LazyLoadingImageRaw = observer('LazyLoadingImageRaw', (props: LazyLoadingImageRawPropsType) => {
    const { alt, className, imgFit, imgBase, imgDeviceSet, onClick, dataTest } = props;
    const [state] = React.useState(() => new LazyImageLoadState(imgBase.src));

    return (
        <picture>
            <DeviceSourceSet imgDeviceSet={imgDeviceSet} />
            <RenderOptimizedVariants
                img={imgBase}
                formats={['avif', 'webp']}
            />
            <ImageRaw
                className={className}
                onClick={onClick}
                data-test={dataTest}
                allowShow={state.allowShow}
                alt={alt}
                decoding='async'
                imgFit={imgFit}
                loading='lazy'
                onLoad={state.onLoad}
                src={imgBase.src}
            />
        </picture>
    );
});
